/*appHeader.js*/



/** appHeader.js */
var stepSearchHeader = 1;
var currentSearchVar = '';



function clearSearchNavigate() {

	var newurl = '/browse';
	window.history.pushState({
		path: newurl
	}, '', newurl);

	try {
		$('.headerSearchGlobalInput').val('');
	} catch (err) {
	}

	try {
		$('#categorySearchHeaderStyle').remove();
		$('.searchHome').removeClass('mat-0-im');
	} catch (err) {
	}

	try {
		onscrolleventbackup_home();
	} catch (err) {
	}



	$('#mainLiveHome').html('');
	$(".headerSearchGlobalInput").val('');
	// $(".headerSearchGlobalInput").removeClass("siteSearchHover");

	$('.sectionContainer').show();
	$('.searchHome').hide();
}


var timeout = null;


var lastClick = 0;
var delay = 20;

// var initClickedBrowserAll=false;

function clickedBrowseAll(idCategory=null, idTag=null, name=null, fromCollection=false, get_type=null) {

    // arrivando dalla pagina video (tap su un tag) l'entry video resta nella
    // history: col router state-driven il back la ri-renderizza correttamente

    // web: una categoria scelta da QUALSIASI punto (dropdown header, griglia
    // categorie del search, tag) marca la voce Categorie del nav col suo nome
    if (window.TY_WEB && idCategory && typeof tyWebNavMarkCategory === 'function') {
        tyWebNavMarkCategory(name);
    }

    // alert(1);
    // Solo naviga se NON viene da una collection
    // if(fromCollection == true) {
    //     alert(2);
    // console.log(nowCurrentPageState);
    // if(nowCurrentPageState.indexOf("collection") !== -1 ){
        // alert("collection now");
        // return false;
    // }
    
    navigateToPage('search', true);
    
    // }
    
    // Il resto del codice rimane uguale...
    if(name && !idCategory && !idTag) {
        $('.searchForMobile').show();
        $('.search-mobile-categories-box').hide();
        $('.headerSearchGlobalInputMobile').val(name);
        $('.headerSearchRemoveIcon').show();
        $('#mobile-logo-native-label').html(translate('SEARCH'));
        searchLiveInLive(1, '', name, '', name, get_type);
    } else {
        $('.search-mobile-categories-box').hide();
        $('.headerSearchGlobalInputMobile').val('');
        $('#mobile-logo-native-label').html(`<span class="header-back-liquid" onclick="checkGeneralCurrentState();"><i class="ri-arrow-left-line"></i></span> ${name}`);
        $('.searchForMobile').hide();
        searchLiveInLive(1, idCategory, '', idTag, name, get_type);
    }
}

function searchLiveInLive(step, idCat, search, tag, name=null, get_type=null) {
    if(!name){
        name = search;
    }
    
    // Salva lo stato SOLO se non siamo già in uno stato searchin
    if(step === 1) {
        var currentState = currentPageState[currentPageState.length-1];
        if(!currentState || currentState.indexOf("searchin") === -1) {
            addPageToState('searchin-'+idCat+'-'+tag+'-'+name);
        }
    }

    stepSearchHeader = step;
    $('.searchedCategories').html('');

    var searchString = '';
    var catString = '';
    var tagString = '';

    if (!!search) {
        searchString = 'search=' + search;
    }

    if (!!idCat) {
        catString = '&cat=' + idCat;
    }

    if (!!tag) {
        tagString = '&tags=' + tag;
    }

    if (lastClick >= (Date.now() - delay))
        return false;

    lastClick = Date.now();

    setTimeout(function () {
        $('#mainLiveHomeMobile').html('');
        $('#mainLiveHomeMobile').show();

        getContentsVertical(URL_API + '?' + searchString + catString + tagString + '&page=' + step + '&get_type='+get_type+'&position=All', '#mainLiveHomeMobile');
    }, 500);
}

function removeItemFromArray(string, value) {

	var ret = string.replace(/value-/g, '');
	return ret;
}

var filterBtnClicked = false;



function clearThisFilterFromSearch(idCategory) {
	$(".category_" + idCategory + "_checkbox").prop('checked', false);
	clickedBrowseAll('', '');
}


function searchNowAfterChange(val){
    window.scrollTo(0, 0);

    if (val != '') {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            if(blockTempSearch==false){
                // IMPORTANTE: usa clickedBrowseAll con parametri vuoti per categoria/tag
                // così usa lo stesso meccanismo delle categorie
                clickedBrowseAll('', '', val, false, null);
            }
        }, 500);

    } else {
        clearTimeout(timeout);
    }
}

function loadChannelHeaderFooter(){

    // La shell web usa il footer di web.js; l'URL legacy ricade sulla shell
    // completa e reiniettarla qui rieseguirebbe il bootstrap dell'app.
    if (!window.TY_WEB) {
        console.log("----------------CARICO FOOTER------------------");
        $.ajax({
            localCache: true,
            cacheTTL: 6,
            url: "https://teyuto.tv/app/html/footer?cid="+CHANNEL_ID,
            method: "GET",
            success: function(data) {
                // solo frammenti: un documento completo (la shell capp, anche
                // da una risposta già in cache jalc) porterebbe <base> e script
                // dell'app, rieseguendo il bootstrap in loop
                if (typeof data !== 'string' || /<(!doctype|html|head|body|base)[\s>]/i.test(data)) {
                    console.warn("Footer ignorato: la risposta non è un frammento HTML");
                    return;
                }
                $("#footerContent").html(data);
            },
            error: function(xhr, status, error) {
                console.error("Errore durante il caricamento del footer:", error);
            }
        });
    }

    console.log("----------------CARICO LE CATEGORIE------------------");
	$.ajax({
		localCache: true,
		cacheTTL: 4,
		type: "GET",
		url: URL_API + "/categories/?f=get_categories&cid="+CHANNEL_ID,
		success: function (json) {
            console.log("----------------CATEGORIE------------------");
            // console.log(json);
			if (json) {
				var obj = JSON.parse(json);
               

				if (obj.length > 0) {
					var resultLength = obj.length;

					for (var i = 0; i < resultLength; i++) {
						if (obj[i].show == 1 || obj[i].show == true) {
							companyNumberCategories++;
                            // tinta (data-tint) e immagine (--cat-img) servono solo alle
                            // tile della ricerca web desktop (web-home.css): il mobile le ignora
                            var catImg = (typeof obj[i].image === 'string' && /^https?:\/\//.test(obj[i].image))
                                ? obj[i].image.replace(/["'()\s\\]/g, function (c) { return '%' + c.charCodeAt(0).toString(16); })
                                : '';
                            $('.mobile-list-categories').append(`<div class="search-cat-tile${catImg ? ' search-cat-tile--img' : ''}" data-tint="${i % 8}"${catImg ? ` style="--cat-img:url('${catImg}')"` : ''} onclick="clickedBrowseAll(${obj[i].id}, null, '${obj[i].name.replace(/'/g, "\\'")}', false);">${obj[i].name}</div>`);
                }
					}

				}
			}

		},
        error: function (err) {
            // alert("errore");
            console.log("---------------CATEGORIES ERROR-------------------");
            // console.log(err);
        }
	});


	
	var searchCatUrl = getUrlParameter("searchCat", window.location.href);
	if (searchCatUrl) {
		clickedBrowseAll(searchCatUrl, '');
	}

	var searchTagUrl = getUrlParameter("searchTag", window.location.href);
	if (searchTagUrl) {
		clickedBrowseAll('', searchTagUrl);
	}

}
